import React, {FunctionComponent, useEffect} from 'react';
import {Callout, Card} from '@blueprintjs/core';
import {useDispatch, useSelector} from 'react-redux';

import {sanitizeHTML} from "../admin/account/components/CustomMessage/utils";
import {IState} from "../../shared/store/reducers";
import {loadCurrentWorkspaceConfig} from "../../shared/store/actions/workspaceConfigActions";

interface CustomMessageCalloutProps {

}

const CustomMessageCallout: FunctionComponent<CustomMessageCalloutProps> = ({}: CustomMessageCalloutProps) => {
  const currentWorkspaceConfig = useSelector((state: IState) => state.workspaces.currentWorkspaceConfig);

  const getConfigValue = (name: string) =>
    currentWorkspaceConfig?.find((config) => config.name === name)?.value || "";

  const customMessageTitle = getConfigValue("custom_message_title");
  const customMessageText = getConfigValue("custom_message_text");
  const customMessageIntent = getConfigValue("custom_message_intent");
  const customMessageIcon = getConfigValue("custom_message_icon");
  const customMessageActive = getConfigValue("custom_message_active");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCurrentWorkspaceConfig());
  }, [dispatch]);

  const sanitizedText = sanitizeHTML(customMessageText);

  if (customMessageActive === 'false' || !customMessageActive) {
    return null;
  }

  return (
    <div className="home__content__message">
      <Card className="home__content__message__card">
        <Callout
          title={customMessageTitle as any}
          icon={customMessageIcon as any}
          intent={customMessageIntent as any}
        >
          <div dangerouslySetInnerHTML={{__html: sanitizedText}}/>
        </Callout>
      </Card>
    </div>
  );
}

export default CustomMessageCallout;
